import {Divider, Space} from 'antd'

import styles from './BrokerDetails.module.scss'
import {logout} from 'modules/auth'
import {useOpen} from 'common/hooks'
import {Box, Button, Text, Modal, UserAvatar} from 'common/components'
import {ProfileForm, PasswordChangeForm, useGetProfile} from '..'

export default function BrokerDetails() {
  const {data: profile} = useGetProfile()

  const handleLogout = () => logout()

  const details = [
    {label: 'Email', value: profile.email},
    {label: 'Phone number', value: profile.phone},
    {label: 'Company name', value: profile.broker.profile.title},
    {
      label: 'License number',
      value: `#${profile.broker.profile.licenceNumber}`,
    },
  ]

  return (
    <>
      <Box align="center" mb={36}>
        <UserAvatar
          className={styles.avatar}
          size={76}
          src={profile.photo}
          alt={profile.firstName}
        />
        <Text as="h2" weight="medium" size="3xl">
          {profile.firstName} {profile.lastName}
        </Text>
      </Box>
      <Divider />
      <ul className={styles.list}>
        {details.map((item) => (
          <li key={item.label} className={styles.item}>
            <Text size="xs" color="grey" mr={24}>
              {item.label}
            </Text>
            <p>{item.value}</p>
          </li>
        ))}
      </ul>
      <Box align="center">
        <Space size={12} align="center">
          <EditDetails />
          <ChangePassword />
          <Button variant="secondary" onClick={handleLogout}>
            log out
          </Button>
        </Space>
      </Box>
    </>
  )
}

const EditDetails = () => {
  const [isOpen, handleOpen, handleClose] = useOpen(false)

  return (
    <>
      <Button variant="secondary" onClick={handleOpen}>
        edit details
      </Button>
      <Modal title="Edit details" open={isOpen} onCancel={handleClose}>
        <ProfileForm onClose={handleClose} />
      </Modal>
    </>
  )
}

const ChangePassword = () => {
  const [isOpen, handleOpen, handleClose] = useOpen(false)

  return (
    <>
      <Button variant="secondary" onClick={handleOpen}>
        change password
      </Button>
      <Modal title="Change password" open={isOpen} onCancel={handleClose}>
        <PasswordChangeForm onClose={handleClose} />
      </Modal>
    </>
  )
}
